import React from 'react';
import { ReactComponent as UserIcon } from '../../../resources/icons/user-no-image.svg';
import { User } from '../../../types';
import { useAuthContext } from '../../../contexts/authContext';

interface Props {
  assignor?: User;
  supervisor?: User;
  contractor?: User;
}

const ProjectParticipants: React.FC<Props> = ({ assignor, supervisor, contractor }) => {
  const { user } = useAuthContext();

  const renderParticipant = (title: string, participant?: User, roleKey?: string) => {
    const isYou = participant?.id === user?.id;

    return (
      <div className="flex flex-col w-fit gap-1">
        <p className="">{title}</p>
        {participant ? (
          <div className="flex items-center gap-1">
            <UserIcon className="w-6 h-4 -ml-1" />
            <span className="text-buttonBlue font-light max-w-[10rem] text-wrap text-start">
              {participant.name} {isYou && <strong>(you)</strong>}
            </span>
          </div>
        ) : (
          <div className="text-[#98A2B3] ml-1">–</div>
        )}
      </div>
    );
  };

  return (
    <div className="flex lg:flex-row flex-col lg:gap-10 gap-5 w-full mt-5 flex-wrap">
      {renderParticipant('Assignor', assignor, 'ASSIGNOR')}
      {renderParticipant('Contractor', contractor, 'CONTRACTOR')}
      {renderParticipant('Supervisor', supervisor, 'SUPERVISOR')}
    </div>
  );
};

export default ProjectParticipants;
